import styled from 'styled-components';

export enum DropZoneState {
  NoTarget,
  InvalidTarget,
  ValidTarget
}

export const DropZone = styled.div<{ state: DropZoneState }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: all;
  z-index: 25;

  background: ${({ state }) => state === DropZoneState.InvalidTarget ? '#ff000022'
                             : state === DropZoneState.ValidTarget ? '#00ff0022' : 'transparent' };
`;